<template>
  <div class="w-full md:pl-[12px] md:pr-[20px] md:max-h-[calc(100vh-170px)] overflow-y-auto pt-[12px] pb-[24px]">
    <span class="block text-[14px] text-[#333] pb-[16px]">Layout Formulir</span>
    <div
      class="relative overflow-hidden bg-[#F4F4F4] rounded-[8px] h-[200px] w-full mb-[24px] grid place-items-center
          !border border-[#e2e2e2]"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/gallery.svg"
        alt="upload"
        width="32"
        height="32"
      >
      <div class="absolute inset-0 flex items-center pointer-events-none">
        <img
          alt="preview"
          class="object-cover w-full h-full hidden"
        >
      </div>
    </div>
    <div class="w-full rounded-[8px] !border border-[#e2e2e2] py-[32px] px-[16px] select-none">
      <span
        v-if="fields.length === 0"
        class="h-[60px] w-full rounded-[8px] !border !border-dashed border-[#E2E2E2] !flex items-center
            justify-center text-center text-[14px] text-[#F95031] px-[16px]"
      >
        Pilih elemen untuk mulai buat form!
      </span>
      <draggable
        v-else
        v-model="localFields"
        tag="div"
        item-key="id"
        class="flex flex-col gap-[24px]"
      >
        <div
          v-for="field, idx in fields"
          :key="field.id"
          class="flex items-end gap-[6px]"
        >
          <span class="min-w-[25px] h-[25px] mb-[36px] rotate-90 !grid place-items-center rounded-[8px] bg-[#F4F4F4] cursor-move">
            <img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/more.svg"
              alt="drag"
              width="21"
              height="21"
            >
          </span>
          <b-form-group
            :label-for="`field-${idx}`"
            class="mb-0 pl-[8px] w-full relative"
          >
            <template #label>
              <span class="text-[#333] text-[14px] font-medium mb-[8px]">{{ field.label }}</span>
            </template>
            <b-form-input
              :id="`field-${idx}`"
              disabled
              class="!bg-[#FFFFFF]"
            />
            <span class="absolute text-[#c7c7d0] top-[35.5px] left-[23px]">{{ field.placeholder }}</span>
          </b-form-group>
          <div class="flex">
            <button
              type="button"
              aria-label="edit"
              :disabled="standarSections.includes(field.section)"
              class="w-[32px] h-[32px] rounded-[8px] grid place-items-center outline-none hover:bg-[#F4F4F4] active:bg-[#E2E2E2] disabled:!bg-white disabled:opacity-60 transition-colors duration-300"
              @click="$emit('openFieldPropsModal', field)"
            >
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/edit-2.svg"
                alt="edit"
                width="24"
                height="24"
              >
            </button>
            <button
              type="button"
              aria-label="remove"
              :disabled="standarSections.includes(field.section)"
              class="w-[32px] h-[32px] rounded-[8px] grid place-items-center outline-none hover:bg-[#F4F4F4] active:bg-[#E2E2E2] disabled:!bg-white disabled:opacity-60 transition-colors duration-300"
              @click="() => removeField(field)"
            >
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/trash.svg"
                alt="remove"
                width="24"
                height="24"
              >
            </button>
          </div>
        </div>
      </draggable>
      <b-button
        type="button"
        variant="primary"
        class="mt-[24px] w-full"
      >
        Daftar Sekarang
      </b-button>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { FIELD_OPTIONS } from '../constants/komlabs-registration'

export default {
  components: { draggable },
  props: {
    banner: {
      type: File,
      default: null,
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editedField: {
        type: 'text', label: '', placeholder: '', required: false,
      },
    }
  },
  computed: {
    localFields: {
      get() {
        return this.fields
      },
      set(value) {
        this.$emit('update:fields', value)
      },
    },
    standarSections() {
      return [...new Set(Object.values(FIELD_OPTIONS.standar).flat().map(f => f.section))]
    },
  },
  methods: {
    removeField(field) {
      const newFields = this.fields.filter(f => f.id !== field.id)
      this.$emit('update:fields', newFields)
    },
  },
}
</script>
